import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import {
  People as PeopleIcon,
  Person as PersonIcon,
  ViewColumn as ViewColumnIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Schedule as ScheduleIcon,
  Flag as FlagIcon,
  Star as StarIcon,
  Work as WorkIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Chat as ChatIcon,
  ContactMail as ContactMailIcon,
  Business as BusinessIcon,
  Done as DoneIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Pause as PauseIcon,
  Error as ErrorIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as AttachMoneyIcon,
  // Novos ícones adicionados
  LocalShipping as LocalShippingIcon,
  Inbox as InboxIcon,
  Timer as TimerIcon,
  Build as BuildIcon,
  PlayArrow as PlayArrowIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Warning as WarningIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  Block as BlockIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  ShoppingCart as ShoppingCartIcon,
  Loyalty as LoyaltyIcon,
  CardGiftcard as CardGiftcardIcon,
  LocalOffer as LocalOfferIcon,
  Label as LabelIcon,
  Bookmark as BookmarkIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Group as GroupIcon,
  SupervisorAccount as SupervisorAccountIcon,
  VerifiedUser as VerifiedUserIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  Dashboard as DashboardIcon,
  Assessment as AssessmentIcon,
  Timeline as TimelineIcon,
  CalendarToday as CalendarTodayIcon,
  Event as EventIcon,
  Room as RoomIcon,
  Language as LanguageIcon,
  Public as PublicIcon,
  VpnKey as VpnKeyIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  Description as DescriptionIcon,
  NoteAdd as NoteAddIcon,
  Notes as NotesIcon,
  Print as PrintIcon,
  Refresh as RefreshIcon,
  Sync as SyncIcon,
  Update as UpdateIcon,
  NewReleases as NewReleasesIcon,
  Announcement as AnnouncementIcon,
  Campaign as CampaignIcon,
  EmojiEvents as EmojiEventsIcon,
  Grade as GradeIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Forum as ForumIcon,
  Comment as CommentIcon,
  RateReview as RateReviewIcon,
  Feedback as FeedbackIcon,
  BugReport as BugReportIcon,
  Report as ReportIcon,
  ReportProblem as ReportProblemIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon,
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
  Explore as ExploreIcon,
  LocalAtm as LocalAtmIcon,
  Storefront as StorefrontIcon,
  AccountBalance as AccountBalanceIcon,
} from "@material-ui/icons";
import { ChromePicker } from "react-color";
import { toast } from "react-toastify";
import { createColumn, updateColumn } from "../../services/kanban";

// Mapa de ícones disponíveis (ordenado alfabeticamente por label)
export const iconOptions = [
  { name: "NoteAdd", label: "Adicionar Nota", icon: NoteAddIcon },
  { name: "Schedule", label: "Agendado", icon: ScheduleIcon },
  { name: "HourglassEmpty", label: "Aguardando", icon: HourglassEmptyIcon },
  { name: "Help", label: "Ajuda", icon: HelpIcon },
  { name: "Announcement", label: "Anúncio", icon: AnnouncementIcon },
  { name: "Archive", label: "Arquivar", icon: ArchiveIcon },
  { name: "ToggleOn", label: "Ativado", icon: ToggleOnIcon },
  { name: "Update", label: "Atualizar", icon: UpdateIcon },
  { name: "RateReview", label: "Avaliar", icon: RateReviewIcon },
  { name: "Assessment", label: "Avaliação", icon: AssessmentIcon },
  { name: "Warning", label: "Aviso", icon: WarningIcon },
  { name: "Flag", label: "Bandeira", icon: FlagIcon },
  { name: "AccountBalance", label: "Banco", icon: AccountBalanceIcon },
  { name: "Block", label: "Bloqueado", icon: BlockIcon },
  { name: "Lock", label: "Bloqueado", icon: LockIcon },
  { name: "Bookmark", label: "Marcador", icon: BookmarkIcon },
  { name: "BugReport", label: "Bug", icon: BugReportIcon },
  { name: "LocalAtm", label: "Caixa", icon: LocalAtmIcon },
  { name: "CalendarToday", label: "Calendário", icon: CalendarTodayIcon },
  { name: "Cancel", label: "Cancelado", icon: CancelIcon },
  { name: "ShoppingCart", label: "Carrinho", icon: ShoppingCartIcon },
  { name: "Chat", label: "Chat", icon: ChatIcon },
  { name: "VpnKey", label: "Chave", icon: VpnKeyIcon },
  { name: "CheckBox", label: "Checkbox Marcado", icon: CheckBoxIcon },
  { name: "IndeterminateCheckBox", label: "Checkbox Indeterminado", icon: IndeterminateCheckBoxIcon },
  { name: "CheckBoxOutlineBlank", label: "Checkbox Vazio", icon: CheckBoxOutlineBlankIcon },
  { name: "ViewColumn", label: "Coluna", icon: ViewColumnIcon },
  { name: "Comment", label: "Comentário", icon: CommentIcon },
  { name: "CheckCircle", label: "Concluído", icon: CheckCircleIcon },
  { name: "Settings", label: "Configurações", icon: SettingsIcon },
  { name: "Build", label: "Construir", icon: BuildIcon },
  { name: "AccountCircle", label: "Conta", icon: AccountCircleIcon },
  { name: "ContactMail", label: "Contato", icon: ContactMailIcon },
  { name: "Dashboard", label: "Dashboard", icon: DashboardIcon },
  { name: "ToggleOff", label: "Desativado", icon: ToggleOffIcon },
  { name: "LockOpen", label: "Desbloqueado", icon: LockOpenIcon },
  { name: "Description", label: "Descrição", icon: DescriptionIcon },
  { name: "CloudDownload", label: "Download", icon: CloudDownloadIcon },
  { name: "Email", label: "Email", icon: EmailIcon },
  { name: "TrendingUp", label: "Em Progresso", icon: TrendingUpIcon },
  { name: "Inbox", label: "Entrada", icon: InboxIcon },
  { name: "LocalShipping", label: "Entrega", icon: LocalShippingIcon },
  { name: "Send", label: "Enviar", icon: SendIcon },
  { name: "Error", label: "Erro", icon: ErrorIcon },
  { name: "Star", label: "Estrela", icon: StarIcon },
  { name: "Label", label: "Etiqueta", icon: LabelIcon },
  { name: "Event", label: "Evento", icon: EventIcon },
  { name: "Explore", label: "Explorar", icon: ExploreIcon },
  { name: "Favorite", label: "Favorito", icon: FavoriteIcon },
  { name: "FavoriteBorder", label: "Favorito Borda", icon: FavoriteBorderIcon },
  { name: "Feedback", label: "Feedback", icon: FeedbackIcon },
  { name: "Done", label: "Feito", icon: DoneIcon },
  { name: "Loyalty", label: "Fidelidade", icon: LoyaltyIcon },
  { name: "AttachMoney", label: "Financeiro", icon: AttachMoneyIcon },
  { name: "Forum", label: "Fórum", icon: ForumIcon },
  { name: "ThumbUp", label: "Gostei", icon: ThumbUpIcon },
  { name: "Group", label: "Grupo", icon: GroupIcon },
  { name: "Language", label: "Idioma", icon: LanguageIcon },
  { name: "Print", label: "Imprimir", icon: PrintIcon },
  { name: "Info", label: "Informação", icon: InfoIcon },
  { name: "PlayArrow", label: "Iniciar", icon: PlayArrowIcon },
  { name: "Room", label: "Localização", icon: RoomIcon },
  { name: "Storefront", label: "Loja", icon: StorefrontIcon },
  { name: "ThumbDown", label: "Não Gostei", icon: ThumbDownIcon },
  { name: "Business", label: "Negócio", icon: BusinessIcon },
  { name: "NewReleases", label: "Novo", icon: NewReleasesIcon },
  { name: "Grade", label: "Nota", icon: GradeIcon },
  { name: "Notes", label: "Notas", icon: NotesIcon },
  { name: "Notifications", label: "Notificações", icon: NotificationsIcon },
  { name: "LocalOffer", label: "Oferta", icon: LocalOfferIcon },
  { name: "VisibilityOff", label: "Oculto", icon: VisibilityOffIcon },
  { name: "Payment", label: "Pagamento", icon: PaymentIcon },
  { name: "Folder", label: "Pasta", icon: FolderIcon },
  { name: "FolderOpen", label: "Pasta Aberta", icon: FolderOpenIcon },
  { name: "Pause", label: "Pausado", icon: PauseIcon },
  { name: "QuestionAnswer", label: "Perguntas e Respostas", icon: QuestionAnswerIcon },
  { name: "Person", label: "Pessoa", icon: PersonIcon },
  { name: "People", label: "Pessoas", icon: PeopleIcon },
  { name: "CardGiftcard", label: "Presente", icon: CardGiftcardIcon },
  { name: "ReportProblem", label: "Problema", icon: ReportProblemIcon },
  { name: "Public", label: "Público", icon: PublicIcon },
  { name: "RadioButtonUnchecked", label: "Radio Desmarcado", icon: RadioButtonUncheckedIcon },
  { name: "RadioButtonChecked", label: "Radio Marcado", icon: RadioButtonCheckedIcon },
  { name: "Refresh", label: "Recarregar", icon: RefreshIcon },
  { name: "Receipt", label: "Recibo", icon: ReceiptIcon },
  { name: "Report", label: "Relatório", icon: ReportIcon },
  { name: "Security", label: "Segurança", icon: SecurityIcon },
  { name: "SupervisorAccount", label: "Supervisor", icon: SupervisorAccountIcon },
  { name: "Sync", label: "Sincronizar", icon: SyncIcon },
  { name: "Assignment", label: "Tarefa", icon: AssignmentIcon },
  { name: "Phone", label: "Telefone", icon: PhoneIcon },
  { name: "Timer", label: "Temporizador", icon: TimerIcon },
  { name: "Work", label: "Trabalho", icon: WorkIcon },
  { name: "EmojiEvents", label: "Troféu", icon: EmojiEventsIcon },
  { name: "CloudUpload", label: "Upload", icon: CloudUploadIcon },
  { name: "VerifiedUser", label: "Usuário Verificado", icon: VerifiedUserIcon },
  { name: "Visibility", label: "Visível", icon: VisibilityIcon },
  { name: "Timeline", label: "Linha do Tempo", icon: TimelineIcon },
];

const ColumnModal = ({ open, onClose, column, boardId, fieldDefinitions = [], onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    color: "#3498db",
    icon: "ViewColumn",
    limit: "",
    registerSale: false,
    sendEmail: false,
    emailRecipients: "",
    emailContent: "",
    requiredFieldNames: [],
  });
  const [loading, setLoading] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);

  useEffect(() => {
    if (column) {
      setFormData({
        name: column.name || "",
        color: column.color || "#3498db",
        icon: column.icon || "ViewColumn",
        limit: column.limit || "",
        registerSale: column.registerSale || false,
        sendEmail: column.sendEmail || false,
        emailRecipients: column.emailRecipients || "",
        emailContent: column.emailContent || "",
        requiredFieldNames: Array.isArray(column.requiredFieldNames) ? column.requiredFieldNames : [],
      });
    } else {
      setFormData({
        name: "",
        color: "#3498db",
        icon: "ViewColumn",
        limit: "",
        registerSale: false,
        sendEmail: false,
        emailRecipients: "",
        emailContent: "",
        requiredFieldNames: [],
      });
    }
  }, [column, open]);

  // Autor: GitHub Copilot | Data: 29/03/2026 | Motivo: oferecer no cadastro de coluna a selecao de campos obrigatorios para movimentacao de cards.
  const availableFieldOptions = React.useMemo(() => {
    const defaultFields = [
      { fieldName: "title", fieldLabel: "Titulo" },
      { fieldName: "description", fieldLabel: "Descricao" },
      { fieldName: "valorReais", fieldLabel: "Valor R$" },
    ];

    const merged = [...defaultFields, ...(fieldDefinitions || [])];
    const uniqueByFieldName = new Map();

    merged.forEach((field) => {
      if (!field?.fieldName) return;
      if (!uniqueByFieldName.has(field.fieldName)) {
        uniqueByFieldName.set(field.fieldName, {
          fieldName: field.fieldName,
          fieldLabel: field.fieldLabel || field.fieldName,
        });
      }
    });

    return Array.from(uniqueByFieldName.values());
  }, [fieldDefinitions]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleColorChange = (color) => {
    setFormData({
      ...formData,
      color: color.hex,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("O nome é obrigatório");
      return;
    }

    // Validar campos de email se a opção estiver habilitada
    if (formData.sendEmail) {
      if (!formData.emailRecipients || !formData.emailRecipients.trim()) {
        toast.error("Os destinatários são obrigatórios quando 'Enviar Emails' está habilitado");
        return;
      }
      if (!formData.emailContent || !formData.emailContent.trim()) {
        toast.error("O conteúdo do email é obrigatório quando 'Enviar Emails' está habilitado");
        return;
      }
    }

    setLoading(true);

    try {
      const data = {
        ...formData,
        limit: formData.limit ? parseInt(formData.limit) : null,
      };

      if (column) {
        // Editando coluna existente
        await updateColumn(column.id, data);
        toast.success("Coluna atualizada com sucesso!");
      } else {
        // Criando nova coluna
        await createColumn({
          ...data,
          boardId: boardId,
        });
        toast.success("Coluna criada com sucesso!");
      }

      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Erro ao salvar coluna");
    } finally {
      setLoading(false);
    }
  };

  // Função para obter o componente de ícone pelo nome
  const getIconComponent = (iconName) => {
    const iconOption = iconOptions.find((opt) => opt.name === iconName);
    return iconOption ? iconOption.icon : ViewColumnIcon;
  };

  const SelectedIcon = getIconComponent(formData.icon);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{column ? "Editar Coluna" : "Nova Coluna"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Nome *"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                margin="dense"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" margin="dense">
                <InputLabel>Ícone</InputLabel>
                <Select
                  value={formData.icon}
                  onChange={(e) =>
                    setFormData({ ...formData, icon: e.target.value })
                  }
                  label="Ícone"
                >
                  {iconOptions.map((option) => {
                    const IconComponent = option.icon;
                    return (
                      <MenuItem key={option.name} value={option.name}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <IconComponent fontSize="small" />
                          <Typography>{option.label}</Typography>
                        </Box>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                padding={2}
                border={1}
                borderColor="divider"
                borderRadius={4}
              >
                <Typography variant="body2">Preview:</Typography>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  padding={1}
                  borderRadius={2}
                  style={{ backgroundColor: formData.color + "20" }}
                >
                  <SelectedIcon
                    fontSize="small"
                    style={{ color: formData.color }}
                  />
                  <Typography style={{ color: formData.color, fontWeight: 600 }}>
                    {formData.name || "Nome da Coluna"}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Limite de Cards (WIP)"
                name="limit"
                type="number"
                value={formData.limit}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                margin="dense"
                helperText="Deixe vazio para sem limite"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" margin="dense">
                <InputLabel>Campos obrigatorios ao mover card</InputLabel>
                <Select
                  multiple
                  value={formData.requiredFieldNames}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      requiredFieldNames: e.target.value,
                    })
                  }
                  label="Campos obrigatorios ao mover card"
                  renderValue={(selected) =>
                    selected
                      .map((fieldName) =>
                        availableFieldOptions.find((field) => field.fieldName === fieldName)?.fieldLabel || fieldName
                      )
                      .join(", ")
                  }
                >
                  {availableFieldOptions.map((field) => (
                    <MenuItem key={field.fieldName} value={field.fieldName}>
                      <Checkbox checked={formData.requiredFieldNames.includes(field.fieldName)} />
                      <Typography>{field.fieldLabel}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.registerSale}
                    onChange={(e) =>
                      setFormData({ ...formData, registerSale: e.target.checked })
                    }
                    color="primary"
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1">
                      Registrar Venda ao Mover Card
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Quando um card for movido para esta coluna, será registrado uma venda na tabela de vendas.
                      O card precisa ter um usuário de venda selecionado e um valor no campo "valorReais".
                    </Typography>
                  </Box>
                }
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.sendEmail}
                    onChange={(e) =>
                      setFormData({ ...formData, sendEmail: e.target.checked })
                    }
                    color="primary"
                  />
                }
                label={
                  <Box>
                    <Typography variant="body1">
                      Enviar Emails
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Quando um card for movido para esta coluna, será enviado um email automático.
                    </Typography>
                  </Box>
                }
              />
            </Grid>

            {formData.sendEmail && (
              <>
                <Grid item xs={12}>
                  <TextField
                    label="Destinatários *"
                    name="emailRecipients"
                    value={formData.emailRecipients}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    multiline
                    rows={2}
                    helperText="Emails separados por vírgula. Suporta coringas: {{assignedUser.email}}, {{contact.email}}, {{cliente.E_MAIL}}"
                    placeholder="exemplo@email.com, {{assignedUser.email}}"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Conteúdo do Email *"
                    name="emailContent"
                    value={formData.emailContent}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    multiline
                    rows={6}
                    helperText="Conteúdo HTML com suporte a coringas: {{title}}, {{description}}, {{assignedUser.name}}, {{customFields.nomeCampo}}, etc."
                    placeholder={`<p>Olá {{assignedUser.name}},</p>
<p>O card <strong>{{title}}</strong> foi movido.</p>
<p>Descrição: {{description}}</p>
<p>Prioridade: {{priority}}</p>`}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box 
                    padding={2}
                    border={1}
                    borderColor="divider"
                    borderRadius={4}
                    bgcolor="action.hover"
                  >
                    <Typography variant="subtitle2" gutterBottom>
                      Coringas Disponíveis:
                    </Typography>
                    <Typography variant="caption" component="div" style={{ lineHeight: 1.8 }}>
                        {`title: {{title}}`}<br/>
                        {`description: {{description}}`}<br/>
                        {`priority: {{priority}}`}<br/>
                        {`creator.name: {{creator.name}}`}<br/>
                        {`cliente.NOMECLI: {{cliente.NOMECLI}}`}<br/>
                        {`cliente.EMAIL: {{cliente.E_MAIL}}`}<br/>
                        {`customFields.qual_produto: {{customFields.qual_produto}}`}<br/>
                        {`customFields.valorReais: {{customFields.valorReais}}`}<br/>
                    </Typography>
                  </Box>
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={6}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => setShowColorPicker(!showColorPicker)}
                style={{
                  marginTop: 8,
                  backgroundColor: formData.color,
                  color: "#fff",
                  height: 56,
                }}
              >
                Escolher Cor
              </Button>
            </Grid>

            {showColorPicker && (
              <Grid item xs={12}>
                <ChromePicker
                  color={formData.color}
                  onChange={handleColorChange}
                  disableAlpha
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="default">
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={loading}>
            {loading ? "Salvando..." : "Salvar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ColumnModal;
